<neo-infobox
  class="cm-infobox"
  [class.cm-infobox--info]="color() === 'info'"
  [message]="message()"
  [urgency]="urgency()"
  [showContent]="showContent()"
>
  <ng-content />
</neo-infobox>
